import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useNavigate } from "react-router-dom";

const SetupWizardSnackbar = () => {
    const [open, setOpen] = React.useState(true);
    const navigate = useNavigate();
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
        localStorage.removeItem("wizard");
    };

    const redirectToWizard = () => {
        return navigate("/setup-wizard");
    };

    const action = (
        <>
            <Button color="secondary" size="small" onClick={redirectToWizard}>
                GO TO WIZARD
            </Button>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    if (!localStorage.getItem("wizard")) return null;
    return (
        <div>
            <Snackbar
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                style={{ marginBottom: "12px" }}
            >
                <Alert
                    icon={<AutoFixHighIcon fontSize="inherit" />}
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: "100%" }}
                    action={action}
                >
                    Use setup wizard for quick onboarding
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SetupWizardSnackbar;
